export const MEDIA_ITEM_FIELDS_FRAGMENT = /* GraphQL */ `
  fragment MediaItemFields on MediaItem {
    sourceUrl
    altText
  }
`;

export const HOME_PAGE_FIELDS_FRAGMENT = /* GraphQL */ `
  fragment HomePageFields on Page {
    homepage {
      merchSection {
        disableSection
        heading
        text
        link {
          target
          title
          url
        }
        merch {
          productName
          productPhoto {
            node {
              ...MediaItemFields
            }
          }
          productPrice
          productUrl {
            target
            title
            url
          }
        }
      }
      mediaText {
        body
        cta {
          target
          title
          url
        }
        image {
          node {
            ...MediaItemFields
          }
        }
        heading
      }
      hero {
        heading
        featuredMatchup
        ctaLink {
          target
          title
          url
        }
        heroImage {
          node {
            ...MediaItemFields
          }
        }
      }
      bannerOne {
        bannerImage {
          node {
            ...MediaItemFields
          }
        }
        mobileBannerImage {
          node {
            ...MediaItemFields
          }
        }
        bannerLink {
          target
          title
          url
        }
      }
      bannerTwo {
        bannerImage {
          node {
            ...MediaItemFields
          }
        }
        mobileBannerImage {
          node {
            ...MediaItemFields
          }
        }
        bannerLink {
          target
          title
          url
        }
      }
      teamsSection {
        disableSection
        showRankrecord
        heading
        text
        link {
          target
          title
          url
        }
      }
      videosSection {
        disableSection
        heading
        text
        youtubePlaylistId
      }
    }
  }
`;

export const ABOUT_PAGE_FIELDS_FRAGMENT = /* GraphQL */ `
  fragment AboutPageFields on Page {
    aboutPage {
      missionStatement
      pageHero {
        heading
        copy
        image {
          node {
            ...MediaItemFields
          }
        }
        mobileImage {
          node {
            ...MediaItemFields
          }
        }
        link {
          target
          title
          url
        }
      }
      teamStory {
        heading
        body
        image {
          node {
            ...MediaItemFields
          }
        }
        cta {
          target
          title
          url
        }
      }
      teamsSection {
        disableSection
        heading
        text
        link {
          target
          title
          url
        }
      }
      peopleSection {
        disableSection
        headline
        subhead
        cta {
          target
          title
          url
        }
        people {
          name
          title
          bio
          headshot {
            node {
              ...MediaItemFields
            }
          }
        }
      }
      sponsors {
        disableSection
        headline
        sponsors {
          image {
            node {
              ...MediaItemFields
            }
          }
          link
        }
      }
    }
  }
`;

export const CONTACT_PAGE_FIELDS_FRAGMENT = /* GraphQL */ `
  fragment ContactPageFields on Page {
    pageHero {
      heading
      copy
      image {
        node {
          ...MediaItemFields
        }
      }
    }
  }
`;

export const SCHEDULE_PAGE_FIELDS_FRAGMENT = /* GraphQL */ `
  fragment SchedulePageFields on Page {
    schedulePage {
      firstSection {
        disableSection
        firstSectionContent {
          headline
          subhead
          cta {
            target
            title
            url
          }
          image {
            node {
              ...MediaItemFields
            }
          }
        }
      }
      secondSection {
        disableSection
        secondSectionContent {
          headline
          subhead
          cta {
            target
            title
            url
          }
          image {
            node {
              ...MediaItemFields
            }
          }
        }
      }
      preFooterContent {
        heading
        content
      }
    }
  }
`;

export const CONTENT_BLOCK_PAGE_FIELDS_FRAGMENT = /* GraphQL */ `
  fragment ContentBlockPageFields on Page {
    contentBlockPage {
      heading
      content
    }
  }
`;

export const EDITOR_BLOCKS_FRAGMENT = /* GraphQL */ `
  fragment EditorBlocks on Page {
    editorBlocks {
      name
      ... on AcfAccordion {
        accordion {
          items {
            headline
            content
          }
        }
      }
      ... on AcfCoachesAndStaff {
        coachesAndStaff {
          headline
          subhead
          cta {
            title
            url
          }
          people {
            name
            title
            bio
            headshot {
              node {
                ...MediaItemFields
              }
            }
          }
        }
      }
      ... on AcfForm {
        gravityForm {
          id
          title
          description
        }
      }
      ... on AcfFullWidthVideo {
        fullWidthVideo {
          headline
          subhead
          cta {
            title
            url
          }
          video
        }
      }
      ... on AcfHighlights {
        blockEditorCategoryName
        highlights {
          headline
          subhead
          cta {
            title
            url
          }
          image {
            node {
              ...MediaItemFields
            }
          }
          highlightPlaylistTags
        }
      }
      ... on AcfMerch {
        merch {
          headline
          subhead
          cta {
            title
            url
          }
          products {
            name
            price
            link
            image {
              node {
                ...MediaItemFields
              }
            }
          }
        }
      }
      ... on AcfPageTitle {
        pageTitle {
          title
        }
      }
      ... on AcfPromoBanner {
        promoBanner {
          headline
          cta {
            title
            url
          }
          image {
            node {
              ...MediaItemFields
            }
          }
        }
      }
      ... on AcfRelatedArticles {
        relatedArticles {
          posts {
            nodes {
              ... on Post {
                id: databaseId
                slug
                title
                content
                date
                author {
                  node {
                    name
                  }
                }
                featuredImage {
                  node {
                    ...MediaItemFields
                  }
                }
              }
            }
          }
        }
      }
      ... on AcfRichText {
        richText {
          content
        }
      }
      ... on AcfSponsors {
        apiVersion
        blockEditorCategoryName
        sponsors {
          headline
          sponsors {
            image {
              node {
                ...MediaItemFields
              }
            }
            link
          }
        }
      }
      ... on AcfStandardHero {
        standardHero {
          headline
          text
          cta {
            title
            url
          }
          image {
            node {
              ...MediaItemFields
            }
          }
        }
      }
      ... on AcfTeamsAndStandings {
        teamsAndStandings {
          headline
          subhead
        }
      }
      ... on AcfTwoUp {
        twoUp {
          section1 {
            headline
            subhead
            cta {
              title
              url
            }
            image {
              node {
                ...MediaItemFields
              }
            }
          }
          section2 {
            headline
            subhead
            cta {
              title
              url
            }
            image {
              node {
                ...MediaItemFields
              }
            }
          }
        }
      }
      ... on AcfWatch {
        watch {
          headline
          subhead
          cta {
            title
            url
          }
          youtubePlaylistId
        }
      }
      ... on AcfWoobox {
        woobox {
          wooboxId
        }
      }
    }
  }
`;

export const WOOBOX_BLOCK_FRAGMENT = /* GraphQL */ `
  fragment WooboxBlock on PostEditorBlock {
    name
    ... on AcfWoobox {
      woobox {
        wooboxId
      }
    }
  }
`;